__turbopack_context__.v({
  "buttonWrapper": "BlockTwoColumnText-module-scss-module__RBBwtG__buttonWrapper",
  "column": "BlockTwoColumnText-module-scss-module__RBBwtG__column",
  "columnInner": "BlockTwoColumnText-module-scss-module__RBBwtG__columnInner",
  "flushBottom": "BlockTwoColumnText-module-scss-module__RBBwtG__flushBottom",
  "flushTop": "BlockTwoColumnText-module-scss-module__RBBwtG__flushTop",
  "heading3": "BlockTwoColumnText-module-scss-module__RBBwtG__heading3",
  "headline": "BlockTwoColumnText-module-scss-module__RBBwtG__headline",
  "largeHeading": "BlockTwoColumnText-module-scss-module__RBBwtG__largeHeading",
  "line": "BlockTwoColumnText-module-scss-module__RBBwtG__line",
  "paragraph": "BlockTwoColumnText-module-scss-module__RBBwtG__paragraph",
  "richEyebrow": "BlockTwoColumnText-module-scss-module__RBBwtG__richEyebrow",
  "tillatip": "BlockTwoColumnText-module-scss-module__RBBwtG__tillatip",
  "tillatipFlex": "BlockTwoColumnText-module-scss-module__RBBwtG__tillatipFlex",
  "tillatipIcon": "BlockTwoColumnText-module-scss-module__RBBwtG__tillatipIcon",
  "tillatipLabel": "BlockTwoColumnText-module-scss-module__RBBwtG__tillatipLabel",
  "twoColumnText": "BlockTwoColumnText-module-scss-module__RBBwtG__twoColumnText",
  "twoColumnTextFlex": "BlockTwoColumnText-module-scss-module__RBBwtG__twoColumnTextFlex",
});
